import { FaInfoCircle } from "react-icons/fa"

const NoDataScreen = ({text = "No hay registros", border = false}) => {

  return (
    <div className={`flex  w-full h-full text-gray-700 items-center justify-center ${border && "border border-gray-300 rounded-lg"}`}>
      <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
          <span className="text-gray-500 whitespace-pre-line max-w-[180px] text-center">{text}</span>
          <FaInfoCircle className="text-gray-500" />
      </div>
    </div>
  )
}

export default NoDataScreen